import {
  triggerToast,
  SidePanelDS,
  TextCapitalized,
  Spacer,
  SelectDS,
} from "@qivia/ui";
import { useMemo, useEffect } from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { useAppDispatch, useAppSelector } from "../../../../../redux/hooks";
import { selectRulesList } from "../../../rules/rulesSlice";
import {
  cardsSlice,
  selectRuleUpdatedStatus,
  updateVehicleRuleAsync,
} from "../cardsSlice";
import { typographies } from "@qivia/ui/src/styles/figmaTypographies";

export const ParametersSectionsCard = (props: {
  isInOpposition: boolean;
  currentRule: string;
  vehicleUuid: string;
}) => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const rules = useAppSelector(selectRulesList);
  const ruleUpdatedStatus = useAppSelector(selectRuleUpdatedStatus);

  const optionRule = useMemo(
    () =>
      rules.map((rule) => {
        return {
          value: rule.uuid,
          label: rule.name,
          disabled: rule.uuid === props.currentRule,
        };
      }),
    [props.currentRule, rules],
  );

  const valueOptionRule = useMemo(
    () => optionRule.find((option) => option.value === props.currentRule),
    [optionRule, props.currentRule],
  );

  useEffect(() => {
    if (ruleUpdatedStatus === "success") {
      triggerToast(t(`cards.updatedRule.success`) || "", "valid");
      dispatch(cardsSlice.actions.resetRuleUpdatedStatus());
    } else if (ruleUpdatedStatus === "failed") {
      triggerToast(t("cards.updatedStatus.failure") || "", "error");
      dispatch(cardsSlice.actions.resetRuleUpdatedStatus());
    }
  }, [ruleUpdatedStatus, t, dispatch]);

  if (props.isInOpposition) {
    return;
  }

  return (
    <SidePanelDS.Section verticalSpacing={2} horizontalSpacing={1.5}>
      <StyledTitle>
        <TextCapitalized>
          {t("cards.sidePanel.informations.title.parameter")}
        </TextCapitalized>
      </StyledTitle>
      <Spacer y={2} />
      <SidePanelDS.SectionRow
        label={
          <StyledSubTitle>
            <TextCapitalized>
              {t("cards.sidePanel.informations.title.rule")}
            </TextCapitalized>
          </StyledSubTitle>
        }
        value={
          <StyledSelect>
            <SelectDS
              label={""}
              width={16}
              placeholder={t("cards.modal.rule.placeholder") || ""}
              value={valueOptionRule}
              options={optionRule}
              onChange={(selectedOption) => {
                selectedOption &&
                  void dispatch(
                    updateVehicleRuleAsync({
                      vehicleUuid: props.vehicleUuid,
                      ruleUuid: selectedOption.value,
                    }),
                  );
              }}
            />
          </StyledSelect>
        }
      />
    </SidePanelDS.Section>
  );
};

const StyledSelect = styled.div`
  height: 2.5rem;
`;

const StyledTitle = styled.div`
  ${typographies["Body/XL"]}
`;

const StyledSubTitle = styled.div`
  ${typographies["Body/L"]}
`;
